var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-wrapper"},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(`filters.groups.facets.${_vm.name}`)))]),_c('span',{staticClass:"reset-link",on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.$t(_vm.resetLabel)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }